var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-container",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(" " + _vm._s(_vm.$ct("settings")) + " "),
                      ]),
                      _c(
                        "w-card-content",
                        { staticClass: "settings-form" },
                        [
                          _c(
                            "w-form-section",
                            {
                              attrs: {
                                label: _vm.$ct(
                                  "calendar-settings.default-event-length"
                                ),
                                stacked: "",
                              },
                            },
                            [
                              _c("w-select", {
                                attrs: { items: _vm.eventLengths },
                                model: {
                                  value: _vm.settings.DefaultEventDuration,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "DefaultEventDuration",
                                      $$v
                                    )
                                  },
                                  expression: "settings.DefaultEventDuration",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-form-section",
                            {
                              attrs: {
                                label: _vm.$ct(
                                  "calendar-settings.first-day-of-week"
                                ),
                                stacked: "",
                              },
                            },
                            [
                              _c("w-select", {
                                attrs: { items: _vm.firstDaysOfWeek },
                                model: {
                                  value: _vm.settings.FirstDayOfWeek,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "FirstDayOfWeek",
                                      $$v
                                    )
                                  },
                                  expression: "settings.FirstDayOfWeek",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-form-section",
                            {
                              attrs: {
                                label: _vm.$ct("calendar-settings.sale-event"),
                                stacked: "",
                              },
                            },
                            [
                              _c("w-select", {
                                attrs: {
                                  label: _vm.$ct(
                                    "calendar-settings.sale-event-color"
                                  ),
                                  items: _vm.saleEventColorMethods,
                                },
                                model: {
                                  value: _vm.settings.SaleEventGetColorMethod,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "SaleEventGetColorMethod",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "settings.SaleEventGetColorMethod",
                                },
                              }),
                              _c("w-switch", {
                                attrs: {
                                  label: _vm.$ct(
                                    "calendar-settings.sale-event-link-delivery-date"
                                  ),
                                },
                                model: {
                                  value:
                                    _vm.settings.SaleEventLinkToDeliveryDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settings,
                                      "SaleEventLinkToDeliveryDate",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "settings.SaleEventLinkToDeliveryDate",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-form-section",
                            {
                              attrs: {
                                label: _vm.$ct(
                                  "calendar-settings.default-reminders"
                                ),
                                stacked: "",
                              },
                            },
                            [
                              _c(
                                "w-link",
                                {
                                  staticClass: "label-link",
                                  attrs: { slot: "label-actions" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addReminder()
                                    },
                                  },
                                  slot: "label-actions",
                                },
                                [
                                  _c("w-fa", {
                                    staticClass: "mrs",
                                    attrs: { icon: "plus" },
                                  }),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "components.calendar.reminders.add-short"
                                      )
                                    ) + " "
                                  ),
                                ],
                                1
                              ),
                              _c("app-calendar-event-reminders", {
                                attrs: {
                                  reminders: _vm.settings.DefaultReminders,
                                  "show-add": false,
                                },
                                on: {
                                  remove: function ($event) {
                                    return _vm.removeReminder($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-card-actions",
                        [
                          _c("w-spacer"),
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.save()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }